











import Vue from 'vue';
import config from '../../../../config';
import TIcons from '../../../types/TIcons';
import { ESocialMediaType } from '../../../common/enums/frontpage.enum';

export default Vue.extend({
  name: `SocialMediaIcon`,
  props: {
    type: {
      required: true,
      validator: (val: ESocialMediaType) => Object.values(ESocialMediaType).includes(val),
    },
  },
  methods: {
    socialMediaIcon(id: ESocialMediaType): string {
      return TIcons.frontpage.socialMedia[id];
    },
    socialMediaUrl(id: ESocialMediaType): string {
      return config.socialMediaUrls[id] ? config.socialMediaUrls[id] : ``;
    },
  },
});
